module.exports = __webpack_public_path__ + "d2f83d3148866d5a4ae47ac2f44dd8da.pdf";